import type { BlockQuickLinks } from 'types/block-quick-links';

import React from 'react';
import Image from 'next/image';
import { Paragraph, Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import { useMatchMedia } from 'hooks/useMatchMedia';

const QuickLinks: React.FC<BlockQuickLinks> = ({
  sectionId,
  instanceId,
  title,
  description,
  links,
}) => {
  const [isMediumScreen] = useMatchMedia(['(min-width: 768px)'], [true]);
  const listInlineStyle = !isMediumScreen
    ? {}
    : {
        gridTemplateRows: `repeat(${Math.ceil(links?.length / 2)}, 0.5fr)`,
      };
  return (
    <Wrap id={sectionId} itemID={`MediaPanel-${instanceId}`}>
      {title || description ? (
        <div className="grid gap-y-6 justify-items-center">
          {title && (
            <HeadingBody
              level="2"
              tagName="h2"
              title={title}
              className="font-semibold text-center"
            />
          )}
          {description && (
            <Paragraph
              dangerouslySetInnerHTML={{ __html: description }}
              size="large"
              className="text-center lg:max-w-5xl"
            />
          )}
        </div>
      ) : null}
      {links?.length > 0 ? (
        <ul
          className="grid md:grid-cols-2 md:grid-flow-col gap-y-2 gap-x-10 content-start items-start"
          style={listInlineStyle}
        >
          {links.map(link => (
            <li key={link.label}>
              <a
                className="flex justify-between items-center cursor-pointer p-4 border border-[#DEE4E8] rounded-md hover:bg-lilac-50"
                href={link.link}
              >
                <span className="text-base font-semibold flex-1">
                  {link.label}
                </span>
                <span className="p-reset inline-grid items-center justify-center w-8 h-8 rounded-full py-3 px-3 border-lilac-300 bg-lilac-300 shrink-0">
                  <Image src="/arrow.svg" alt="arrow" width="15" height="12" />
                </span>
              </a>
            </li>
          ))}
        </ul>
      ) : null}
    </Wrap>
  );
};

export default QuickLinks;
